import { closeInvoiceDetail } from './modalApi';
import { invoiceListHandlersRef } from './invoiceListHandlersRef';

export function afterInvoiceActionSuccess(setter) {
    if (typeof setter === 'function') {
        setter(false);
    }
    closeInvoiceDetail();
    const handlers = invoiceListHandlersRef.current;
    if (handlers?.refreshCurrentPage) {
        handlers.refreshCurrentPage();
    }
}

export function rejectFailedResponse(response) {
    const status = response?.status ?? response?.response?.status;
    if (status >= 400) {
        return Promise.reject(response?.response ? response : { response });
    }
    return response;
}

export function detailFromError(err, fallback) {
    const detail = err.response?.data?.detail;
    if (typeof detail === 'string' && detail.trim()) {
        return detail;
    }
    return fallback;
}
